// XXX: import does not work here if the import is not used
require("castle.js");

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _castle: any;
  }
}
const castleAppId = process.env.REACT_APP_CASTLE_APP_ID;

function castleFn(action: "trackPageview" | "identify" | "reset", id?: string) {
  if (castleAppId) {
    window._castle(action, id);
  }
}

const init = () => {
  if (castleAppId) {
    window._castle("setAppId", castleAppId);
    window._castle("autoTrack", false);
  }
};

const trackPageView = () => {
  castleFn("trackPageview");
};

const identify = (id: string) => {
  castleFn("identify", id);
};

const reset = () => {
  castleFn("reset");
};

const CastleProvider = { reset, identify, trackPageView, init };

export default CastleProvider;
